module.exports = __webpack_public_path__ + "img/ercode_ddz.d5d85407.png";